import type { SizeOptionWithEdd } from '../domain/models/CustomizationOptions';
import { isNDDDate } from '@/features/pdp/utils/eddFormatting';

const LENGTH_CATEGORIES = ['Chains', 'Mangalsutra Chains', 'Necklaces', 'Anklets'];

export function getSizeSectionLabel(category: string): string {
  return LENGTH_CATEGORIES.includes(category) ? 'Length (in inches)' : 'Size';
}

export function getSizeSelectPlaceholder(category: string): string {
  return LENGTH_CATEGORIES.includes(category) ? 'Length' : 'Size';
}

export function getDesktopSizerLinkLabel(category: string): string {
  const sizeLabel = getSizeSectionLabel(category);
  const placeholder = getSizeSelectPlaceholder(category);
  if (sizeLabel === 'Length (in inches)') {
    return `Not sure about the ${placeholder.toLowerCase()}?`;
  }
  return 'Not sure about the size?';
}

export function isNddSize(
  size: SizeOptionWithEdd,
  nddAvailableSizes: string[] | null
): boolean {
  if (nddAvailableSizes?.includes(size.key)) return true;
  if (size.eddFullDate) return isNDDDate(size.eddFullDate);
  return false;
}
